import React from 'react';
import pt from 'prop-types';

import { hasPermission } from 'utils';
import { getBaseAndTestEnvPath } from 'utils/container';

import NavItem from './item';

import './nav.scss';

const { BASE_URI } = process.env;

export default class NavGroup extends React.PureComponent {
  static propTypes = {
    items: pt.array,
    heading: pt.string,
    location: pt.object,
  };

  static contextTypes = {
    isAdvancedUserPermissions: pt.bool,
    user: pt.object.isRequired,
  };

  getActiveItem(items = []) {
    const { location } = this.props;
    const { baseUri } = getBaseAndTestEnvPath();
    let activeItem = null;

    // Strip the dynamic base (e.g. the partner dashboard's /:partnerId prefix)
    // so links like '/stores' match '/{partnerId}/stores'. A no-op for admin.
    let basePath = location.pathname;
    if (baseUri && basePath.startsWith(baseUri)) {
      basePath = basePath.slice(baseUri.length);
    }

    const pathname = `${basePath
      .replace(BASE_URI, '')
      .replace(/^\/test[^/]*/, '')
      .replace(/\/$/, '')}`;
    const uri = `${pathname}${location.search}`;

    try {
      for (const item of items) {
        if (this.isItemActive(item, pathname, uri)) {
          if (item.break && activeItem) {
            break;
          }
          activeItem = item;
        }
      }
    } catch (err) {
      console.log(err);
    }

    return activeItem;
  }

  isItemActive(item, pathname, uri) {
    if (item.exact) {
      if (item.link === pathname) {
        return true;
      }
    } else {
      if (item.link === '/' && (pathname === '/' || pathname === '')) {
        return true;
      } else if (item.link !== '/' && uri.startsWith(item.link)) {
        return true;
      }
    }

    if (item.items) {
      const childItems = item.items.filter(Boolean);
      for (const childItem of childItems) {
        if (this.isItemActive(childItem, pathname, uri)) {
          return true;
        }
      }
    }

    return false;
  }

  render() {
    const { heading, items, location, ...props } = this.props;
    const { isAdvancedUserPermissions = false, user } = this.context;

    const navItems = items;
    const activeParentItem = this.getActiveItem(navItems);

    let activeChildItem = null;
    for (const item of navItems) {
      if (item.items) {
        const activeItem = this.getActiveItem(item.items);
        if (activeItem) {
          activeChildItem = activeItem;
        }
      }
    }

    const navItemChildren = navItems.reduce((acc, item, index) => {
      if (
        hasPermission(user, item.permission, item.link, {
          isAdvancedUserPermissions,
        })
      ) {
        acc.push(
          <NavItem
            {...props}
            index={index}
            key={`${index}.${item.link}`}
            path={index}
            isActive={activeParentItem === item}
            activeChildItem={activeChildItem}
            otherItems={navItems.filter((i) => i !== item)}
            {...item}
          />,
        );
      }

      return acc;
    }, []);

    if (navItemChildren.length <= 0) {
      return null;
    }

    return (
      <div className="nav-group">
        <h4 className="nav-group-heading">{heading}</h4>

        <ul className="nav-group-list">{navItemChildren}</ul>
      </div>
    );
  }
}
